import React from 'react';
import '../styles/App.css';
import 'bootstrap/dist/css/bootstrap.css';
import PoliciesContainer from "./PoliciesContainer";

function App() {
  return (
    <div className="App">
      <PoliciesContainer/>
    </div>
  );
}

export default App;
